import './App.css';

// React 
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

// Toastify
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Components 
import Header from "./components/Header";
import Footer from "./components/Footer";

// Sections
import HeroSection from './sections/home/Hero';
import PressLogos from './sections/home/PressLogos';
import ProblemCards from './sections/home/ProblemCards';
import FeaturesIllustrated from './sections/home/FeaturesIllustrated';
import FeaturesDetailed from './sections/home/FeaturesDetailed';
import Testimonials from './sections/home/Testimonials';
import AdvisoryBoard from './sections/home/AdvisoryBoard';
import Partners from './sections/home/Partners';
import InvestorsBox from './sections/home/InvestorsBox';
import FAQ from './sections/home/FAQ';
import Quote from './sections/home/Quote';
import Contact from './sections/home/Contact';
import AnnouncementBanner from "./sections/home/AnnouncementBanner";
import PrivacyContent from "./sections/legal/PrivacyContent";
import ImprintContent from "./sections/legal/ImprintContent";

// Matomo
import { useMatomo } from '@jonkoops/matomo-tracker-react';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/privacy' element={<Privacy/>} />
          <Route path='/imprint' element={<Imprint/>} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

function Home() {
  const { trackPageView, trackEvent } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView()
  }, [trackPageView])


  // Move to page section when hash is present in URL
  let location = useLocation();

  useEffect(() => {
    if(location.hash) {
      trackEvent({ category: location.hash, action: 'url-change' });
      const position = document.getElementById(location.hash.replace('#', ''))?.offsetTop;
      if(position) {
        window.scrollTo({ top: position - 120, behavior: 'smooth' });
      }
    } else {
      trackEvent({ category: '#', action: 'url-change' });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.hash, trackEvent]);

  const announcement = {
    msg: "Book a FREE 30min 🎯 expert-call and get ✅ exclusive pre-launch access!",
    link: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
};

  return (
    <div className="App">
      <AnnouncementBanner message={announcement.msg} link={announcement.link} />
      <Header />
      <HeroSection />
      <PressLogos />
      <ProblemCards />
      <FeaturesIllustrated/>
      <FeaturesDetailed />
      <Testimonials />
      <AdvisoryBoard />
      <Partners />
      <InvestorsBox />
      <FAQ />
      <Quote />
      <Contact />
      <Footer />
      <ToastContainer />
    </div>
  )
}

function Privacy() {
  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView()
  }, [trackPageView])

  return (
    <div className="App">
      <Header />
        <PrivacyContent />
      <Footer />
    </div>
  )
}

function Imprint() {
  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView()
  }, [trackPageView])

  return (
    <div className="App">
      <Header />
        <ImprintContent />
      <Footer />
    </div>
  )
}

export default App;
